import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { Typography, Paper, LinearProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import useStyles from "@/styles/powerManagerStyle";
import useAlarmStyles from "@/styles/alarmStyle";
import { useTranslation } from "@/langs/useTranslation";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import dayjs from "dayjs";
import { RefreshRounded } from "@material-ui/icons";
import { numRegex } from "@/helpers/regex";
import {
  dateInLocal,
  dateInUTC,
  timeInLocal,
  timeInNormal,
  scheduledDateInUTC
} from "@/helpers/datetimeHandlers";
import AddEventDialog from "@/components/powerManagement/AddEventDialog";
import {
  dotColor,
  // switchBackTitle,
  deployStatusDotColor,
  executeStatusColor
} from "@/helpers/powerManagerHelper";
import {
  createEventApi,
  editEventApi,
  deleteEventApi,
  getEvenApi
} from "@/apis/powerManagerApi";
import textNoty from "@/helpers/textNoty";
import DeleteDialog from "@/components/powerManagement/DeleteDialog";
import ScheduleViewMode from "@/components/FormFields/ScheduleViewMode";
import ScheduleSelectType from "@/components/commons/ScheduleSelectType";
import { FormItem } from "@/components/Form";
import { useGlobalState } from "@/GlobalProvider";
import SubmitButton from "@/components/commons/SubmitButton";
import { useUpdateEffect } from "ahooks";
import {
  getCalendarEventListApi,
  getCalendarEventExecutionStatusApi
} from "@/apis/apiCollection";
import showLoadingIndicator, {
  hideLoadingIndicator
} from "@/components/Modal/showLoadingIndicator";
import { getScheduleTaskType } from "../CreateTemplate/TaskCreator/TaskType";

const localeInfo = {
  en: null, // require('@fullcalendar/core/locales/en'),
  es: require("@fullcalendar/core/locales/es"),
  fr: require("@fullcalendar/core/locales/fr"),
  jp: require("@fullcalendar/core/locales/ja"),
  kr: require("@fullcalendar/core/locales/ko"),
  ru: require("@fullcalendar/core/locales/ru"),
  zh_cn: require("@fullcalendar/core/locales/zh-cn"),
  zh_tw: require("@fullcalendar/core/locales/zh-tw")
};

const useLinearProgressStyles = makeStyles(theme => ({
  root: {
    borderRadius: 5,
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%"
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700]
  },
  bar: {
    // borderRadius: 5,
    backgroundColor: "var(--barColor, #3491FA)"
  }
}));

const BorderLinearProgress = props => {
  const classes = useLinearProgressStyles();
  return (
    <LinearProgress
      classes={classes}
      {...props}
      style={{ "--barColor": props["data-color"] }}
    />
  );
};

const ScheduleEvents = ({ viewType, deviceSerialNumber }) => {
  const { t, userLanguage } = useTranslation("powerManagement");
  const classes = useStyles();
  const alarmClasses = useAlarmStyles();
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [dialogLoading, setDialogLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);

  const [addDialigOpen, setAddDialogOpen] = useState(false);
  const [time, setTime] = useState(new Date());
  const [task, setTask] = useState("start");
  const [startDate, setStartDate] = useState(new Date());
  const [times, setTimes] = useState(1);
  const [loopType, setLoopType] = useState("daily");
  const [dailyType, setDailyType] = useState("every");
  const [dailyTimes, setDailyTimes] = useState(1);
  const [weeklyTimes, setWeeklyTimes] = useState(1);
  const [weeklySelect, setWeeklySelect] = useState({
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false,
    sun: false
  });
  const [endType, setEndType] = useState("datetime");
  const [endDate, setEndDate] = useState(new Date());
  const [selectType, setSelectType] = useState(
    deviceSerialNumber ? "device" : "group"
  );
  const [selectCompany] = useState("");
  const [groupId, setGroupId] = useState([]);
  const [tagId, setTagId] = useState([]);
  const [device, setDevice] = useState(
    deviceSerialNumber
      ? { id: deviceSerialNumber, name: deviceSerialNumber }
      : {}
  );
  const [editData, setEditData] = useState();
  const [templates, setTemplates] = useState([]);
  const [viewMode, setViewMode] = useState(viewType || 1);
  const [deleteDialigOpen, setDeleteDialogOpen] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const queryMode = useRef("submit");

  const { currentCompanyId } = useGlobalState();
  const history = useHistory();

  const deviceSerialNumberRef = useRef(deviceSerialNumber);

  // get EventApi
  const getEventsHandler = async () => {
    try {
      setLoading(true);
      setEvents([]);
      const res = await (viewMode === 1
        ? getCalendarEventListApi
        : getCalendarEventExecutionStatusApi)(
        groupId,
        tagId,
        deviceSerialNumberRef.current ? undefined : device.id,
        deviceSerialNumberRef.current,
        device.id ? 0 : tagId.length ? 2 : 1, // 0设备 1门店 2标签
        dateInUTC(start),
        dateInUTC(end)
      );
      const oldArray = res.eventsCalendars.concat(res.foreverEvents);
      const newArray = oldArray.map(
        ({
          id,
          start_date,
          end_date,
          groups_id,
          task_type,
          task_schedules_id,
          ext,
          exec_device_count,
          total_device_count,
          exec_status,
          deploy_status
        }) => ({
          id: id,
          borderColor: end_date,
          backgroundColor: task_schedules_id,
          textColor: groups_id,
          // prettier-ignore
          title: getScheduleTaskType(task_type, ext),
          start: dateInLocal(start_date),
          end: dateInLocal(dayjs(end_date).add(1, "days")),
          time: timeInNormal(start_date),
          task_type,
          exec_device_count: exec_device_count || 0,
          total_device_count: total_device_count || 0,
          exec_status,
          deploy_status
        })
      );
      setEvents(newArray);
      setTemplates(res.templates);
    } finally {
      setLoading(false);
    }
  };

  const refresh = () => {
    getEventsHandler();
  };

  const handleQuery = () => {
    queryMode.current = "submit";
    refresh();
  };

  const resetQuery = () => {
    queryMode.current = "reset";
    deviceSerialNumberRef.current = undefined;
    setGroupId([]);
    setTagId([]);
    setDevice({});
    setViewMode(1);
    setSelectType("group");
  };

  useEffect(() => {
    if (start && end) {
      refresh();
    }
  }, [end, start, currentCompanyId]);

  useUpdateEffect(() => {
    if (queryMode.current === "reset") {
      refresh();
    }
  }, [groupId, tagId, device, viewMode]);

  useUpdateEffect(() => {
    refresh();
  }, [viewMode]);

  const refreshTool = {
    text: <RefreshRounded onClick={() => refresh()} />
  };

  const disiableTool = {
    text: (
      <div className="fc-toolbar-chunk fc-disabled">
        <div className="fc-button-group">
          <div disabled={true} className="fc-prev-button fc-button">
            <span className="fc-icon fc-icon-chevron-left"></span>
          </div>
          <div
            disabled={true}
            className="fc-next-button fc-button fc-button-primary"
          >
            <span className="fc-icon fc-icon-chevron-right"></span>
          </div>
        </div>
        <div
          disabled={true}
          className="fc-today-button fc-button fc-button-primary"
        >
          {t("common.backToday")}
        </div>
        <div
          disabled={true}
          className="fc-button fc-refreshTool-button-disabled"
        >
          <RefreshRounded />
        </div>
      </div>
    )
  };

  // render event style
  const renderEventContent = eventInfo => {
    const { extendedProps } = eventInfo.event;
    return (
      <>
        <div
          className="event-outer"
          key={eventInfo.id}
          title={eventInfo.event.title}
        >
          {viewMode === 2 && (
            <BorderLinearProgress
              variant="determinate"
              data-color={executeStatusColor(extendedProps.exec_status)}
              value={
                extendedProps.exec_status === "failed"
                  ? 100
                  : (extendedProps.exec_device_count /
                      (extendedProps.total_device_count || 1)) *
                    100
              }
            />
          )}
          <div className={classes.eventInner}>
            <div
              className={classes.dot}
              // style={{ background: dotColor(eventInfo.event.extendedProps.task_type) }}
              style={{
                background: deployStatusDotColor(extendedProps.deploy_status)
              }}
            />
            <div className={classes.eventTime}>
              {timeInLocal(eventInfo.event.borderColor)}
            </div>
            <div>{eventInfo.event.title}</div>
            {viewMode === 2 && (
              <div className={classes.stats}>
                {extendedProps.exec_device_count}/
                {extendedProps.total_device_count}
              </div>
            )}

            {/* <HasPermission permission="power_management_delete_task">
            <Tooltip title={t("dialog.delete")} placement="right">
              <div className="fc-cancel">
                <img
                  src={CancelIcon}
                  alt="delete"
                  id="Delete"
                  onClick={event => deleteHandler(eventInfo, event)}
                />
              </div>
            </Tooltip>
          </HasPermission> */}
          </div>
        </div>
      </>
    );
  };

  // change month event
  const changeMonth = dateInfo => {
    setEnd(dateInfo.endStr);
    setStart(dateInfo.startStr);
  };

  // delete event
  const deleteHandler = (eventInfo, e) => {
    if (loading) {
      return;
    }
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      setDeleteData(eventInfo.event);
      setDeleteDialogOpen(true);
    } else {
      setDeleteData(editData.event);
      setDeleteDialogOpen(true);
    }
  };

  const deleteConfirm = async () => {
    try {
      setDialogLoading(true);
      const response = await deleteEventApi(
        deleteData.backgroundColor,
        t,
        t("noty.delete")
      );
      if (response && response.status && response.status === "success") {
        await getEventsHandler();
        setDeleteDialogOpen(false);
        setAddDialogOpen(false);
      }
    } finally {
      setDialogLoading(false);
    }
  };

  // select date to show add dialog
  const handleDateSelect = selectInfo => {
    // if (!addPermission) {
    //   return;
    // }
    if (loading) {
      return;
    }
    setEditData();
    const currentDay = dayjs().format("YYYY-MM-DD");
    const start = dayjs(selectInfo.startStr).format("YYYY-MM-DD");
    if (dayjs(start).isBefore(currentDay)) {
      textNoty(t("dialog.minDateMessage"));
      return;
    }
    setLoopType("daily");
    setTimes(1);
    setEndType("datetime");
    setDailyType("every");
    setDailyTimes(1);
    setWeeklySelect({
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      sun: false
    });
    setWeeklyTimes(1);
    setTime(new Date());
    setStartDate(selectInfo.startStr);
    setEndDate(dayjs(selectInfo.endStr).subtract(1, "days"));
    setAddDialogOpen(true);
    setTask("start");
  };

  // add events
  const onConfirmAdd = async () => {
    const currentDay = dayjs().format("YYYY-MM-DD");
    const start = dayjs(startDate).format("YYYY-MM-DD");
    const end = dayjs(endDate).format("YYYY-MM-DD");
    const startDayAddOne = dayjs(start).add(1, "days");
    // loop type daily and every days no value
    if (
      loopType === "daily" &&
      dailyType === "every" &&
      (!dailyTimes || dailyTimes < 1 || !numRegex.test(dailyTimes))
    ) {
      textNoty(t("dialog.loopTypeTimeAtLeastOneDay"));
      return;
    }

    if (loopType === "weekly") {
      // loop type weekly and every weeks no value
      if (!weeklyTimes || weeklyTimes < 1 || !numRegex.test(weeklyTimes)) {
        textNoty(t("dialog.loopTypeTimeAtLeastOneWeek"));
        return;
      }
      // loop type weekly and no select day
      if (!Object.values(weeklySelect).includes(true)) {
        textNoty(t("dialog.loopTypeTimeAtLeastSelectADay"));
        return;
      }
      // End date equal start
      if (endType === "datetime" && dayjs(end).isBefore(startDayAddOne)) {
        textNoty(t("dialog.oneDayLater"));
        return;
      }
    }
    // end date less than start date
    if (endType === "datetime" && dayjs(end).isBefore(start)) {
      textNoty(t("dialog.endLessThanStart"));
      return;
    }
    // no times
    if (endType === "times" && (!times || times < 1 || !numRegex.test(times))) {
      textNoty(t("dialog.noTimes"));
      return;
    }
    // start date less than current date
    if (dayjs(start).isBefore(currentDay)) {
      textNoty(t("dialog.minDateMessage"));
      return;
    }
    try {
      setDialogLoading(true);
      await createEventApi(
        groupId,
        selectCompany,
        tagId,
        selectType,
        task,
        loopType,
        dailyType,
        dailyTimes,
        weeklyTimes,
        weeklySelect,
        endType,
        times,
        `${scheduledDateInUTC(dayjs(start + " " + timeInNormal(time)))}`,
        `${scheduledDateInUTC(dayjs(end + " " + timeInNormal(time)))}`,
        t,
        t("noty.create")
      );
      await getEventsHandler();
      setAddDialogOpen(false);
    } finally {
      setDialogLoading(false);
    }
  };
  //edit events
  const handleEventClick = async clickInfo => {
    try {
      // if (!editPermission) {
      //   return;
      // }
      const { event, jsEvent } = clickInfo;
      const { extendedProps } = event;
      showLoadingIndicator();
      if (jsEvent.target.id === "Delete" || loading) {
        return;
      }
      setEditData();
      let res = await getEvenApi(event.backgroundColor);
      let data = res?.events;
      if (data) {
        // prettier-ignore
        const hasEndDateTime = data.json.end_type === "datetime" && data.json.end_date;
        // prettier-ignore
        const { exec_status, exec_device_count, total_device_count } = extendedProps;
        if (exec_status === "completed" || exec_status === "failed") {
          // prettier-ignore
          const executeStatus = exec_status === "completed" ? "success" : exec_status;
          // prettier-ignore
          const isScheduleFailedFinally = exec_status === "failed" && exec_device_count === total_device_count;
          // prettier-ignore
          // history.push(
          //   ['/schedule/history?',
          //   `scheduleTemplateId=${data.schedule_template_id}`,
          //   `&taskType=${data.task_type}`,
          //   `${isScheduleFailedFinally ? '' : `&executedStatus=${executeStatus}`}`,
          //   `&startDate=${dayjs(isScheduleFailedFinally ? event.start : data.json.start_date).startOf("d").valueOf()}`,
          //   `&endDate=${hasEndDateTime ? dayjs(data.json.end_date).endOf("d").valueOf() : ""}`].join("")
          // );

          history.push(
            ['/schedule/history?',
            `scheduleTemplateId=${data.schedule_template_id}`,
            `&taskType=${data.task_type}`,
            `&startDate=${dayjs(event.start).startOf("d").valueOf()}`,
            `&endDate=${dayjs(event.start).endOf("d").valueOf()}`].join("")
          );
          return;
        }
        setStartDate(dateInLocal(data.json.start_date || new Date()));
        setEndDate(dateInLocal(data.json.end_date || new Date()));
        setEditData(clickInfo);
        // setTask(switchBackTitle(event.title));
        setTask(extendedProps.task_type);
        setTime(data.json.end_date || new Date());
        setLoopType(data.schedule_type || "daily");
        setEndType(data.json.end_type || "datetime");
        setTimes(data.json.run_times || 1);
        setDevice(data.ext);
        if (data.type === "daily") {
          setDailyTimes(data.json.cycle_value || 1);
          setWeeklyTimes(1);
          setWeeklySelect({
            mon: false,
            tue: false,
            wed: false,
            thu: false,
            fri: false,
            sat: false,
            sun: false
          });
          setDailyType(data.json.cycle_type || "every");
        } else {
          if (data.json.cycle_days) {
            let result = {
              mon: false,
              tue: false,
              wed: false,
              thu: false,
              fri: false,
              sat: false,
              sun: false
            };
            data.json.cycle_days.forEach(e => (result[e] = true));
            setWeeklySelect(result);
          } else {
            setWeeklySelect({
              mon: false,
              tue: false,
              wed: false,
              thu: false,
              fri: false,
              sat: false,
              sun: false
            });
          }
          setDailyType("every");
          setDailyTimes(1);
          setWeeklyTimes(data.json.cycle_value || 1);
        }
        setAddDialogOpen(true);
      }
    } finally {
      hideLoadingIndicator();
    }
  };

  const onConfirmEdit = async () => {
    const start = dayjs(startDate).format("YYYY-MM-DD");
    const end = dayjs(endDate).format("YYYY-MM-DD");
    const startDayAddOne = dayjs(start).add(1, "days");

    // loop type daily and every days no value
    if (
      loopType === "daily" &&
      dailyType === "every" &&
      (!dailyTimes || dailyTimes < 1 || !numRegex.test(dailyTimes))
    ) {
      textNoty(t("dialog.loopTypeTimeAtLeastOneDay"));
      return;
    }

    if (loopType === "weekly") {
      // loop type weekly and every weeks no value
      if (!weeklyTimes || weeklyTimes < 1 || !numRegex.test(weeklyTimes)) {
        textNoty(t("dialog.loopTypeTimeAtLeastOneWeek"));
        return;
      }
      // loop type weekly and no select day
      if (!Object.values(weeklySelect).includes(true)) {
        textNoty(t("dialog.loopTypeTimeAtLeastSelectADay"));
        return;
      }
      // End date equal start
      if (endType === "datetime" && dayjs(end).isBefore(startDayAddOne)) {
        textNoty(t("dialog.oneDayLater"));
        return;
      }
    }
    // end date less than start date
    if (endType === "datetime" && dayjs(end).isBefore(start)) {
      textNoty(t("dialog.endLessThanStart"));
      return;
    }
    // no times
    if (endType === "times" && (!times || times < 1 || !numRegex.test(times))) {
      textNoty(t("dialog.noTimes"));
      return;
    }
    setDialogLoading(true);
    const response = await editEventApi(
      editData.event.backgroundColor,
      selectType,
      selectCompany,
      groupId,
      tagId,
      task,
      loopType,
      dailyType,
      dailyTimes,
      weeklyTimes,
      weeklySelect,
      endType,
      times,
      `${scheduledDateInUTC(dayjs(start + " " + timeInNormal(time)))}`,
      `${scheduledDateInUTC(dayjs(end + " " + timeInNormal(time)))}`,
      t,
      t("noty.create"),
      setDialogLoading
    );
    if (response) {
      await getEventsHandler();
      textNoty(t("noty.update"), "success");
      setAddDialogOpen(false);
      setDialogLoading(false);
      setEditData();
    }
  };

  const closeAddOrEdit = () => {
    setAddDialogOpen(false);
    setEditData();
  };

  return (
    <div className={alarmClasses.main}>
      <Paper elevation={0}>
        <div className={alarmClasses.tableHeader}>
          <div className={alarmClasses.tableTop}>
            <Typography variant="h5" component="span">
              {t({ defaultMessage: "设备排程日历" })}
            </Typography>
          </div>
          <div className={alarmClasses.tableQueryForm}>
            <FormItem
              label={t({ defaultMessage: "查看模式" })}
              className={alarmClasses.formItem}
            >
              <ScheduleViewMode
                value={viewMode}
                onChange={e => setViewMode(e.target.value)}
              />
            </FormItem>
            <ScheduleSelectType
              groupId={groupId}
              setGroupId={setGroupId}
              setSelectType={setSelectType}
              selectType={selectType}
              tagId={tagId}
              setTagId={setTagId}
              device={device}
              setDevice={setDevice}
            />
            <FormItem className={alarmClasses.formItem}>
              <SubmitButton
                variant="contained"
                color="primary"
                type="submit"
                loading={loading && queryMode.current === "submit"}
                style={{ marginRight: 8 }}
                onClick={handleQuery}
              >
                {t({ defaultMessage: "查询" })}
              </SubmitButton>
              <SubmitButton
                variant="outlined"
                loading={loading && queryMode.current === "reset"}
                onClick={resetQuery}
              >
                {t({ defaultMessage: "重置" })}
              </SubmitButton>
            </FormItem>
          </div>
          <div>
            <FormItem label={t({ defaultMessage: "排程模板" })}>
              {templates.map((item, i) => (
                <React.Fragment key={item.id}>
                  <Link to={`/schedule/template/info/${item.id}`}>
                    {item.name}
                  </Link>
                  {i < templates.length - 1 ? "、" : ""}
                </React.Fragment>
              ))}
            </FormItem>
          </div>
        </div>
        <div className={loading ? classes.disabledCalendar : ""}>
          <FullCalendar
            locale={localeInfo[userLanguage]?.default}
            initialView="dayGridMonth"
            defaultAllDay={true}
            events={events}
            nextDayThreshold="00:00:00"
            plugins={[dayGridPlugin, interactionPlugin]}
            select={handleDateSelect}
            selectMirror={true}
            editable={false}
            droppable={false}
            eventStartEditable={false}
            // selectable={!loading}
            selectable={false}
            eventOrder={["time"]}
            dayMaxEvents={true}
            contentHeight={850}
            eventContent={renderEventContent}
            eventClick={handleEventClick}
            // eventChange={eventChange}
            customButtons={{ disiableTool, refreshTool }}
            datesSet={dateInfo => {
              changeMonth(dateInfo);
            }}
            headerToolbar={{
              left: loading ? "disiableTool" : "prev,next today refreshTool",
              center: "title",
              right: ""
            }}
            buttonText={{
              today: t("common.backToday")
            }}
          />
        </div>
      </Paper>
      <AddEventDialog
        readOnly
        loading={dialogLoading}
        setTime={setTime}
        time={time}
        task={task}
        setTask={setTask}
        ext={device}
        onConfirmEdit={onConfirmEdit}
        onConfirmAdd={onConfirmAdd}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
        open={addDialigOpen}
        times={times}
        setTimes={setTimes}
        setEndType={setEndType}
        endType={endType}
        dotColor={dotColor}
        timeInLocal={timeInLocal}
        setLoopType={setLoopType}
        loopType={loopType}
        dailyType={dailyType}
        setDailyType={setDailyType}
        dailyTimes={dailyTimes}
        editData={editData}
        setDailyTimes={setDailyTimes}
        weeklyTimes={weeklyTimes}
        setWeeklyTimes={setWeeklyTimes}
        weeklySelect={weeklySelect}
        setWeeklySelect={setWeeklySelect}
        onClose={() => closeAddOrEdit(false)}
        deleteHandler={deleteHandler}
      />
      <DeleteDialog
        open={deleteDialigOpen}
        timeInLocal={timeInLocal}
        deleteData={deleteData}
        dotColor={dotColor}
        loading={dialogLoading}
        onConfirm={deleteConfirm}
        onClose={() => setDeleteDialogOpen(false)}
      />
    </div>
  );
};

export default ScheduleEvents;
